import { ColumnType } from '../components/Kanban2/type'

const getTotalValueFromColumn = (column: ColumnType) => {
  if (!column.cardList) return 0

  return column.cardList.reduce((acc, card) => {
    const valueTag = card.tags?.find((tag) => tag.value?.includes('R$'))

    if (!valueTag?.value) return acc

    const cleaned = valueTag.value
      .replace(/R\$\s?/, '') // Remove "R$" e espaço
      .replace(/\u00A0/g, '') // Remove espaço inquebrável
      .replace(/\./g, '') // Remove pontos (milhar)
      .replace(',', '.') // Troca vírgula por ponto decimal

    const numeric = Number(cleaned)

    return acc + (Number.isNaN(numeric) ? 0 : numeric)
  }, 0)
}

export default getTotalValueFromColumn
